import React, { FC } from 'react';
import { Feather } from '@expo/vector-icons';
import { TouchableOpacity, View } from 'react-native';

import { Body1Reg, Caption1Bold } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { SPACING } from '../../../config/designSystem/Spacing';

interface StepperFieldProps {
  label: string;
  value: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
}

/** The design's number field with small up/down chevrons (nighttime awakenings). */
export const StepperField: FC<StepperFieldProps> = ({
  label,
  value,
  min = 0,
  max = 20,
  onChange,
}) => {
  return (
    <View style={{ flex: 1, rowGap: SPACING['sp-8'] }}>
      <Caption1Bold color={COLORS.content.primary}>{label}</Caption1Bold>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: COLORS.surface.contrast,
          borderRadius: SPACING['sp-12'],
          borderWidth: 1,
          borderColor: COLORS.border.secondary,
          paddingVertical: SPACING['sp-4'],
          paddingHorizontal: SPACING['sp-16'],
          minHeight: 46,
        }}
      >
        <Body1Reg>{String(value)}</Body1Reg>
        <View>
          <TouchableOpacity
            onPress={() => onChange(Math.min(value + 1, max))}
            hitSlop={{ top: 6, bottom: 2, left: 8, right: 8 }}
          >
            <Feather name="chevron-up" size={16} color={COLORS.content.secondary} />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => onChange(Math.max(value - 1, min))}
            hitSlop={{ top: 2, bottom: 6, left: 8, right: 8 }}
          >
            <Feather name="chevron-down" size={16} color={COLORS.content.secondary} />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};
